import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { t as tr } from "@/lib/tr";

// Wiederverwendbarer mobiler Navigations-Drawer für interne Backends (Admin + Super)
const tid = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const MobileNav = ({ title, items, footer, dark = false }) => {
  // Backend läuft komplett auf Weiß – der alte `dark`-Schalter bleibt für
  // Bestandsaufrufe erhalten, wirkt aber nicht mehr.
  void dark;
  const [open, setOpen] = useState(false);
  const idle = "text-stone-600 hover:bg-stone-100 hover:text-stone-900 border-l-4 border-transparent";
  const activeCls = "bg-neutral-100 font-bold border-l-4 border-stone-900";
  return (
    <>
      <button onClick={() => setOpen(true)} aria-label={tr("app:s.menueOeffnen")} data-testid="mobile-nav-button"
        className={`md:hidden p-2 -ms-1 rounded-lg text-stone-700 hover:bg-stone-100`}>
        <Menu className="w-5 h-5" />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" data-testid="mobile-nav-drawer" aria-describedby={undefined}
          className={`w-[85vw] max-w-xs p-0 flex flex-col bg-white`}>
          <SheetHeader className={`px-4 py-3 border-b text-start border-stone-200`}>
            <SheetTitle className={`break-words font-head `}>{title}</SheetTitle>
          </SheetHeader>
          <nav className="flex-1 overflow-y-auto p-3 space-y-1" data-testid="mobile-nav-list">
            {items.map((n, i) => n.header ? (
              <p key={`h-${i}`} className={`px-3 pt-3 pb-1 text-[11px] font-bold uppercase tracking-wider text-stone-500`}>{n.label}</p>
            ) : n.to ? (
              <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${tid(n.label)}`}
                className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium ${isActive ? activeCls : idle}`}>
                {n.icon && <n.icon className="w-4 h-4 shrink-0" />} <span className="min-w-0 break-words">{n.label}</span>
              </NavLink>
            ) : (
              <button key={n.label} onClick={() => { setOpen(false); n.onClick?.(); }}
                data-testid={`mobile-nav-${tid(n.label)}`}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-start ${n.className || idle}`}>
                {n.icon && <n.icon className="w-4 h-4 shrink-0" />} <span className="min-w-0 break-words">{n.label}</span>
              </button>
            ))}
          </nav>
          {footer && <div className={`p-3 border-t pb-safe border-stone-200`}>{footer}</div>}
        </SheetContent>
      </Sheet>
    </>
  );
};
